import { render, staticRenderFns } from "./BigInput.vue?vue&type=template&id=15b59f5e"
import script from "./BigInput.vue?vue&type=script&lang=js"
export * from "./BigInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports